export const DateUtil = {
    formatDate: (date: Date) => {
        return date.getFullYear() + '/' + date.getMonth()
    }
}